import React, {FunctionComponent} from "react";

const styles = require('./articleImage.component.scss');


interface ArticleImageProps {
    image: string,
    size: "big" | "small"
    tag?: string
}

export const ArticleImage: FunctionComponent<ArticleImageProps> = ({image, size, tag}) => {
    return (
        <div className={`${styles.container} ${styles[size]}`}>
            <img src={image} />
            {tag && tag !== "Uncategorized" &&
            <div className={styles.label}>{tag}</div>
            }
        </div>
    );
};